module.exports = __webpack_public_path__ + "static/img/fernando-brasil-XM_2oqcbpIQ-unsplash_thumb.182cb47.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/fernando-brasil-XM_2oqcbpIQ-unsplash_thumb.png
// module id = +p/f
// module chunks = 4